import React from "react";
import { esDieciocho } from "../../lib/dieciocho";
import Banderines from "./Banderines";
import EnlaceDieciocho from "./EnlaceDieciocho";

// El Dieciocho en la LANDING, o sea sin sesión (pedido del fundador,
// 2026-09-17: "tiene que verse sin sesión también"). Quien ya entró tiene el
// saludo de Benito, que sabe de su turno; el visitante no tiene Benito, así
// que aquí habla la app, en el mismo registro público de las piezas de redes.
//
// El texto sigue el criterio editorial aprobado: saluda a quien trabaja el
// feriado SIN heroizarlo y sin comparar a quien celebra con quien cuida (por
// eso no dice nada del tipo "el país celebra y tú trabajas"). Sin promesas y
// sin vender.
//
// Se retira sola: fuera del 17 al 19 de septiembre `esDieciocho` devuelve
// false y el componente no renderiza nada (fail-safe hacia no molestar).
export default function SaludoDieciocho() {
  if (!esDieciocho()) return null;
  return (
    <div className="mb-8" data-testid="saludo-dieciocho">
      <Banderines className="mb-5" />
      {/* Dos líneas y en este orden por pedido del fundador (2026-09-17):
          la landing la lee CUALQUIERA, así que el saludo es para todos, y el
          reconocimiento a quien está de turno va debajo, sin dejar fuera a
          quien tiene el día libre. La versión anterior saludaba solo a quien
          trabajaba y dejaba afuera al resto. */}
      <div className="flex items-center justify-center gap-2">
        {/* La MISMA estrella del punto de la i del lockup (clase compartida en
            index.css): un solo gesto en el header, la landing y el feed. Es
            decoración, así que el lector de pantalla solo lee el texto. */}
        <span className="estrella-bandera h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <p className="text-body font-sans text-ink font-semibold">
          Feliz Dieciocho a todos!
        </p>
      </div>
      <p className="mt-1 text-small font-sans text-ink-subtle text-center">
        Y en especial a quien lo pasa de turno.
      </p>
      {/* La invitación a leer la fecha, para quien no es de Chile. Discreta y
          solo por iniciativa de la persona. */}
      <EnlaceDieciocho className="mt-1" />
    </div>
  );
}
